'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown, SvgDelete, SvgLogo } from '@common/__generated__/icon';
import { Divider } from '@common/components';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { Fragment, useEffect, useState } from 'react';
import { getStaticCdnUrl } from '@/utils';
const BANNER_IMAGES = [{
  src: getStaticCdnUrl('/donation/guide-banner-1.png'),
  alt: '가이드 롤링 배너 이미지-1'
}, {
  src: getStaticCdnUrl('/donation/guide-banner-2.png'),
  alt: '가이드 롤링 배너 이미지-2'
}, {
  src: getStaticCdnUrl('/donation/guide-banner-3.png'),
  alt: '가이드 롤링 배너 이미지-3'
}, {
  src: getStaticCdnUrl('/donation/guide-banner-4.png'),
  alt: '가이드 롤링 배너 이미지-4'
}];
const TAX_DEDUCTION_INFO = [{
  label: '10만 원 까지',
  rate: '100% 세액공제'
}, {
  label: '20만 원 이하',
  rate: '44% 세액공제'
}, {
  label: '그외 초과분',
  rate: '16.5% 세액공제'
}];
const BannerSection = () => {
  const $ = _c(32);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loop: true,
      align: "center"
    };
    t1 = [Autoplay({
      delay: 1500,
      stopOnInteraction: false
    })];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t0, t1);
  const [isReady, setIsReady] = useState(false);
  let t2;
  let t3;
  if ($[2] !== emblaApi) {
    t2 = () => {
      if (!emblaApi) {
        return;
      }
      const onInit = () => {
        setIsReady(true);
      };
      if (emblaApi.slideNodes().length > 0) {
        setIsReady(true);
      }
      emblaApi.on("init", onInit);
      return () => {
        emblaApi.off("init", onInit);
      };
    };
    t3 = [emblaApi];
    $[2] = emblaApi;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgLogo className="h-38 min-w-112 mobile:h-19 mobile:min-w-60" />;
    t5 = <SvgDelete className="size-28 mobile-sm:size-14" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center gap-9">{t4}{t5}<div className="relative h-46 w-163 mobile:h-20 mobile:w-80"><Image src={getStaticCdnUrl("agency-logo-mois.png")} alt={"\uD589\uC815\uC548\uC804\uBD80 \uB85C\uACE0"} fill={true} loading="lazy" sizes="(max-width: 850px) 80px, 163px" className="object-contain" /></div></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col items-center gap-40 text-center mobile:gap-20">{t6}<p className="font-800 text-Gray-black typo-h2 mobile:font-700 mobile:typo-h3">웰로에서 기부하면<br />받는 게 많아집니다</p></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      y: 20
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = isReady ? 1 : 0;
  const t10 = isReady ? 0 : 20;
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = {
      opacity: t9,
      y: t10
    };
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.3,
      ease: "easeOut"
    };
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex">{[...BANNER_IMAGES, ...BANNER_IMAGES].map(_temp)}</div>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== emblaRef || $[16] !== t11) {
    t14 = <motion.div ref={emblaRef} initial={t8} animate={t11} transition={t12} className="w-full overflow-hidden">{t13}</motion.div>;
    $[15] = emblaRef;
    $[16] = t11;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 0,
      y: 20
    };
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const t16 = isReady ? 1 : 0;
  const t17 = isReady ? 0 : 20;
  let t18;
  if ($[19] !== t16 || $[20] !== t17) {
    t18 = {
      opacity: t16,
      y: t17
    };
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      duration: 0.3,
      delay: 0.1,
      ease: "easeOut"
    };
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex w-full items-center px-40 mobile:px-20">{TAX_DEDUCTION_INFO.map(_temp2)}</div>;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  let t22;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      y: [0, 8, 0]
    };
    t22 = {
      duration: 0.8,
      repeat: Infinity,
      ease: "easeInOut"
    };
    $[24] = t21;
    $[25] = t22;
  } else {
    t21 = $[24];
    t22 = $[25];
  }
  let t23;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="flex w-full flex-col items-center gap-24 pb-120 mobile:gap-12 mobile:pb-60">{t20}<motion.div animate={t21} transition={t22} className="text-Gray-400"><SvgChevrondown className="size-40 mobile:size-24" /></motion.div></div>;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t18) {
    t24 = <motion.div initial={t15} animate={t18} transition={t19} className="flex w-full flex-col items-center gap-32">{t23}</motion.div>;
    $[27] = t18;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  let t25;
  if ($[29] !== t14 || $[30] !== t24) {
    t25 = <section className="mt-60 flex flex-col items-center gap-112 bg-Gray-white mobile:gap-56">{t7}{t14}{t24}</section>;
    $[29] = t14;
    $[30] = t24;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  return t25;
};
export default BannerSection;
function _temp(image, index) {
  return <div key={index} className="relative mr-66 aspect-square min-w-0 flex-[0_0_206px] mobile:mr-33 mobile:flex-[0_0_180px] tablet:mr-40 tablet:flex-[0_0_220px]"><Image src={image.src} alt={image.alt} width={360} height={360} sizes="(max-width: 750px) 180px, 360px" className="size-full object-contain" /></div>;
}
function _temp2(info, index_0) {
  return <Fragment key={info.label}>{index_0 > 0 && <Divider variant="vertical" className="mx-20 h-48 shrink-0 bg-Gray-300 mobile:mx-10 mobile:h-24" />}<div className="flex flex-1 flex-col items-center gap-2 text-center mobile:gap-0"><p className="font-600 text-Gray-black typo-h5 mobile:typo-caption1">{info.label}</p><p className="font-700 text-O-500 typo-h4 mobile:typo-body4">{info.rate}</p></div></Fragment>;
}